<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	created() {},
};
</script>

<style lang="scss">
@import '@/style/General.scss';
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@100;200;300;400;500;700&display=swap');
body {
	margin: 0;
	font-family: 'Sora', sans-serif !important;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	text-align: left;
	background-color: #ecf0fa;
}

body::-webkit-scrollbar {
	width: 0.45rem;
}
body::-webkit-scrollbar-track {
	background: #1e1e24;
}
body::-webkit-scrollbar-thumb {
	background-color: $scroll-bg;
}
/* #app {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
} */
</style>

